import { Link, useNavigate, useParams } from 'react-router-dom'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { Serie, Territorio } from '../../types'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Page from '../../components/Page'
import Header from '../../components/Header'
import { useDeleteSerie, useSerie, useUpdateSerie } from '../../hooks/serie'
import SerieForm from '../../components/SerieForm'
import { useDeleteTerritorio, useTerritorio, useUpdateTerritorio } from '../../hooks/territories'
import TerritorioForm from '../../components/TerritorioForm'

export default function TerritoryEdit() {
  const { id } = useParams()
  const { data: territorio } = useTerritorio(+id!)
  const deleteTerritorio = useDeleteTerritorio()
  const updateTerritorio = useUpdateTerritorio()
  const [modalRm, modalRmActions] = useModalTrigger<Territorio>()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/territories">Territori</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {territorio!.title.it}
            </li>
          </ol>
        </nav>
        <button
          className="btn  btn-danger"
          onClick={() => modalRmActions.open(territorio)}
        >
          <i className="bi bi-trash3-fill"></i> Elimina
        </button>
      </Header>

      <div className="py-3 overflow-y-auto flex-1">
        <TerritorioForm
          territorio={territorio}
          save={(formTerritorio) =>
            updateTerritorio.mutateAsync(formTerritorio).then(() =>
              toast.success('Territorio salvato con successo!', {
                position: 'bottom-right',
                theme: 'colored',
              })
            )
          }
        />
      </div>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare il territorio {modalRm.value.title.it} ?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btnoutline-primary"
          >
            Annulla
          </button>
          <button
            className="btn  btn-danger"
            disabled={deleteTerritorio.isLoading}
            onClick={async () => {
              await deleteTerritorio.mutateAsync(modalRm.value!.id)
              navigate('/territories')
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
    </Page>
  )
}
